import { type ReactNode } from 'react';
import cx from 'classnames';

import { type SavedDocumentAuthor } from 'src/data/savedDocument';

import { getInitials } from '../lib/utils';

import styles from './CommentAuthor.module.scss';

interface CommentAuthorProps {
  className?: string;
  user: Pick<SavedDocumentAuthor, 'name'>;
  subtitle?: string;
  actions?: ReactNode;
}

export const CommentAuthor = ({ className, user, subtitle, actions }: CommentAuthorProps) => (
  <div className={cx(styles.root, className)}>
    <span className={styles.avatar}>{getInitials(user.name)}</span>
    <div className={styles.details}>
      <span className={styles.name}>{user.name}</span>
      {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
    </div>
    {actions && <div className={styles.actions}>{actions}</div>}
  </div>
);
